import React, { useState, useEffect } from 'react';
import * as Helpers from "../../global/Helpers";
import { useTranslation } from "react-i18next";
import { Person, BarChartLine, GraphUp, CardText } from 'react-bootstrap-icons';
import { ComponentChildCode } from '../../constants/Constants';
import ChartCopyProfile from '././MainChart/ChartCopyProfile';
import Stats from './Stats/Stats';
import PortfolioCopyProfile from './PortfolioCopyProfile';
import Feed from './Feed/Feed';
import './CopyPeopleProfile.css'

import ProfileCard from './ProfileCard';



const CopyPeopleProfile = (props) => {
    
    const { i18n } = useTranslation();

    const DefaultOpen = 1;
    const [openedTab, setOpenedTab] = useState(DefaultOpen);


    /* Transfer component mounted */
    useEffect(() => {
        /* componentDidMount */

        openTab(null, DefaultOpen);
    }, [])

    let ml2Localized = "ml-2";
    let leftLocalized = "left";
    let dir = "ltr";
    var height = "150px";

    if (Helpers.getIsIPad()) {
        height = "185px";
    }

    if (i18n.language === "ar") {
        ml2Localized = "mr-2";
        leftLocalized = "right";
        dir = "rtl";
    }

    function openTab(evt, tab) {
        var i, tablinksCopyPeople;
        setOpenedTab(tab);
        tablinksCopyPeople = document.getElementsByClassName("CopyPeopleProfiletablinks");

        for (i = 0; i < tablinksCopyPeople.length; i++) {
            tablinksCopyPeople[i].className = tablinksCopyPeople[i].className.replace(" active", "");
        }
        if (tablinksCopyPeople.length !== 0)
            if (evt) {
                evt.currentTarget.className += " active";
            } else {
                tablinksCopyPeople[0].className += " active";
            }
    }

    return (
        <div className="settingsSize custom-scrollable">
            <div className="display-vertically" style={{ position: "absolute", height: "calc(100% - " + "65px )", width: "100%", overflowY: "scroll" }}>

                <div className=" CopyPeopleProfile custom-scrollable display-vertically" style={{ height: "100%", width: "100%", direction: dir }}>
                    {
                        Helpers.getIsIPad()
                            ? <div className="vertical-center  MobileTabHeader" style={{ width: "100%", height: "35px" }}>
                                <div className={"mt-2 mb-2 " + ml2Localized + " MobileTabHeaderTitle"} style={{ float: leftLocalized }}>
                                    <strong>{i18n.t("transfersTitle")}</strong>
                                </div>
                            </div>
                            : null
                    }


                    <div className='nav-profile'>
                        {/* ProfileCard */}
                        <div>
                            <ProfileCard />
                        </div>

                        <>
                            {/* tabs buttons */}

                            {/* <hr className="no-margin-no-padding" /> */}
                            <div className="tab-custom" style={{ width: "70%", justifyContent: "center", marginTop: "4%", backgroundColor: "transparent", marginInline: "-15%" }} >
                                <div style={{ float: leftLocalized }}>
                                    <button className="CopyPeopleProfiletablinks" onClick={(e) => openTab(e, 1)} >
                                        <CardText size={12} color={'gray'} className="btn-image-Transfer" />
                                        <strong className="lableCustomized">  {i18n.t("feed")} </strong>
                                    </button>

                                    <button className="CopyPeopleProfiletablinks" onClick={(e) => openTab(e, 2)}>
                                        <GraphUp size={12} color={'gray'} className="btn-image-Transfer" />
                                        <strong className="lableCustomized">  {i18n.t("stats")} </strong>
                                    </button>

                                    <button className="CopyPeopleProfiletablinks" onClick={(e) => openTab(e, 3)}>
                                        <Person size={12} color={'gray'} className="btn-image-Transfer" />
                                        <strong className="lableCustomized">  {i18n.t("portfolioTitle")} </strong>
                                    </button>

                                    <button className="CopyPeopleProfiletablinks" onClick={(e) => openTab(e, 4)}>
                                        <BarChartLine size={12} color={'gray'} className="btn-image-Transfer" />
                                        <strong className="lableCustomized">  {i18n.t("chartTitle")} </strong>
                                    </button>

                                </div>
                            </div>
                        </>


                    </div>

                    <div style={{ height: "calc(100% - " + height + ")", width: "100%" }}>
                        {
                            openedTab === 1
                                ? <div style={{ height: "100%", overflowY: "auto" }}>
                                    <Feed
                                        screenid={props.screenid}
                                        isDarkMode={props.theme == "dark" ? true : false} 
                                    />
                                </div>

                                : openedTab === 2
                                    ?
                                    <div style={{ height: "98%", overflowY: "auto", width: "95%", marginInline: "1%", background: props.theme == "dark" ? "#000": "#fff", marginTop: "10px", borderRadius: "10px" }}>
                                        <Stats isDarkMode={props.theme == "dark" ? true : false} />
                                    </div>


                                    : openedTab === 3
                                        ? <div style={{ height: "100%", overflowY: "auto", width: "100%" }}>
                                            <PortfolioCopyProfile  isDarkMode={props.theme == "dark" ? true : false}/>
                                        </div>


                                        : openedTab === 4
                                            ? <div style={{ height: "100%", overflowY: "auto", width: "100%" }}>
                                                <ChartCopyProfile isDarkMode={props.theme == "dark" ? true : false} />
                                            </div>
                                            : null

                        }
                    </div>
                </div >
            </div >
        </div >



    );
};

export default CopyPeopleProfile;